module.exports = __webpack_public_path__ + "assets/favicon-16x16.996bdc07.png";